import Model from "../Model";

class KpiGraphsComercialClientUser2 extends Model{

    buildUrl ({ param }) {
        return ['kpizoneclientview/infobyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiGraphsComercialClientUser2;